import { captureEvent } from '@sentry/react';
import { useEffect, useState } from 'react';
import type { StatusPageSummaryResponse } from 'typings/StatusPageScheduledMaintenance';

export function useIncidentStatus() {
  const [errorStatus, setErrorStatus] = useState<string>();

  useEffect(() => {
    fetch('https://status.apollographql.com/api/v1/summary')
      .then(async (result) => {
        const resultJson = JSON.parse(
          await result.text(),
        ) as unknown as StatusPageSummaryResponse;
        const [ongoingIncident] = resultJson.ongoing_incidents ?? [];
        if (ongoingIncident) {
          setErrorStatus(ongoingIncident.name);
        }
      })
      .catch(() => captureEvent(new Error('Failed to fetch incident status')));
  }, []);

  return errorStatus;
}
